import { useState } from 'react';

function CppLanguageModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to C++ Programming",
      content: [
        "What is C++ Programming?",
        "History and Features of C++",
        "Setting up the C++ development environment",
        "Structure of a C++ program",
        "Basic syntax and comments in C++",
        "Compiling and running C++ programs",
        "Introduction to Standard Template Library (STL)"
      ]
    },
    {
      title: "Module 2: Data Types and Variables in C++",
      content: [
        "Primitive Data Types in C++: int, char, float, double",
        "Modifiers: short, long, signed, unsigned",
        "Variable declaration and initialization",
        "Constants, literals, and enumerations",
        "Typecasting and type conversion",
        "Input and output in C++ (cin, cout)"
      ]
    },
    {
      title: "Module 3: Control Flow and Loops",
      content: [
        "If-else statements in C++",
        "Switch case statements",
        "Loops: for loop, while loop, do-while loop",
        "Nested loops and control statements",
        "Break and continue",
        "Logical and relational operators"
      ]
    },
    {
      title: "Module 4: Functions in C++",
      content: [
        "Defining and calling functions",
        "Function parameters and return types",
        "Function overloading and inline functions",
        "Scope of variables: local vs global",
        "Recursion in C++",
        "Default arguments and function templates"
      ]
    },
    {
      title: "Module 5: Object-Oriented Programming in C++",
      content: [
        "Introduction to OOP concepts: Classes and Objects",
        "Constructors and destructors",
        "Inheritance and polymorphism",
        "Encapsulation and abstraction",
        "Virtual functions and pure virtual functions",
        "Operator overloading and friend functions",
        "Templates and exception handling"
      ]
    },
    {
      title: "Module 6: Arrays and Pointers",
      content: [
        "Introduction to arrays in C++",
        "Declaring and initializing arrays",
        "Multidimensional arrays",
        "Pointer basics and pointer arithmetic",
        "Pointers with arrays and functions",
        "Dynamic memory allocation: new and delete",
        "Passing arrays and pointers to functions"
      ]
    },
    {
      title: "Module 7: Strings in C++",
      content: [
        "String manipulation using C++ string class",
        "String functions: length, find, substr, etc.",
        "Character arrays and string handling functions",
        "String input and output",
        "Dynamic memory allocation for strings",
        "String concatenation and comparison"
      ]
    },
    {
      title: "Module 8: File Handling in C++",
      content: [
        "File handling basics in C++",
        "Reading and writing files: ifstream, ofstream",
        "File open modes and closing files",
        "Binary file operations",
        "File pointers and functions (seekg, seekp)",
        "Error handling in file operations"
      ]
    },
    {
      title: "Module 9: Standard Template Library (STL)",
      content: [
        "Introduction to STL",
        "Containers: vector, list, deque, stack, queue, map, set",
        "Iterators in STL",
        "Algorithms in STL",
        "Manipulating collections with STL",
        "Custom comparators in STL containers"
      ]
    },
    {
      title: "Module 10: Advanced C++ Topics",
      content: [
        "Memory management and smart pointers",
        "Lambda expressions and function objects",
        "Multithreading and concurrency",
        "Move semantics and rvalue references",
        "C++11/14/17 features",
        "Advanced data structures and algorithms"
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">C++ Language Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px' }}>{item}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CppLanguageModule;
